<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL of TECHNOLOGY</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">ECE & EE</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                            <th class="time">Diploma</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time text-nowrap">Bachelor of Technology (Electronics and Communication
                                Engineering)
                            </td>
                            <td class="time text-nowrap">Diploma in Electrical Engineering</td>
                        </tr>
                        <tr>
                            <td class="time text-nowrap">Bachelor of Technology (Electrical Engineering)</td>
                            <td class="time text-nowrap"></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">ECE & EE ((Electronics and Communication Engineering)</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Technology (Electronics and Communication
                    Engineering) </b>
                    – The B.Tech in ECE program at ARNI School of Technology is designed to equip students with
                    foundational principles and specialized topics related to the field of electronics and communication
                    engineering. There are eight semesters in this four-year degree program.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester I</b> : Foundation</p>
                <ul>
                    <li> Engineering Mathematics-I</li>
                    <li> Engineering chemistry/ Physics-I</li>
                    <li> English for Communications</li>
                    <li> Introduction to Manufacturing Processes</li>
                    <li> Ordinary Differential Equations</li>
                    <li> Basic Electrical and Electronics Engineering</li>
                    <li> Fundamentals of Data Science</li>
                    <li> Physics Laboratory/ Chemistry Laboratory</li>

                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester II
                </b>: Fundamentals of Engineering</p>
                <ul>
                    <li> Engineering Mathematics-II</li>
                    <li> Engineering Chemistry/ Physics-II</li>
                    <li> Introduction to Programming and Data</li>
                    <li> English for Communication or Learning English/ Mechanics</li>
                    <li> Introduction to Programming and Data Structures</li>
                    <li> Introduction to Sensors and IoT</li>
                    <li> Digital Logic Design</li>
                    <li> Chemistry Laboratory/ Physics Laboratory</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester III
                </b>: Core Engineering Concepts</p>
                <ul>
                    <li> Conversational Skills and Etiquette</li>
                    <li> Discrete Mathematics</li>
                    <li> Python Programming</li>
                    <li> Web Programming</li>
                    <li> Semiconductor Physics</li>
                    <li> Introduction to Material Science and Engineering</li>
                    <li> Signal and Systems</li>
                    <li> Introduction to Electronics Lab</li>
                    <li> Project - I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester IV
                </b>: Advanced Systems</p>
                <ul>
                    <li> Analog Communication</li>
                    <li> Lateral I</li>
                    <li> Breadth I</li>
                    <li> Matlab Programming</li>
                    <li> PCB Design</li>
                    <li> Digital Electronic Circuits</li>
                    <li> Environmental Science Technology and Management</li>
                    <li> Digital Electronics Circuit lab</li>
                    <li> Project - II</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester V
                </b>: Specialized Studies and Applications</p>
                <ul>
                    <li> Lateral II</li>
                    <li> Breadth II</li>
                    <li> Electromagnetic waves and Radiating Systems</li>
                    <li> Digital Communications</li>
                    <li> Microprocessor and Microcontroller</li>
                    <li> VLSI Design</li>
                    <li> Microprocessor and Microcontroller Lab</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester VI
                </b>: Industry-Aligned Learning</p>
                <ul>
                    <li> Lateral III</li>
                    <li> Breadth III</li>
                    <li> Digital Signal processing</li>
                    <li> Control Systems</li>
                    <li> Embedded Systems and Robotics</li>
                    <li> Elective - I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester VII
                </b>: Research and Innovation</p>
                <ul>
                    <li> Innovation and Entrepreneurship</li>
                    <li> Data Base Management Systems</li>
                    <li> Digital Communication Systems</li>
                    <li> Theory of Computation</li>
                    <li> RF and Microwave Engineering</li>
                    <li> Elective – II</li>
                    <li> Project/ Seminar</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester VIII
                </b>: Capstone Project & Career Readiness</p>
                <ul>
                    <li> Compiler Design</li>
                    <li> Elective – III</li>
                    <li> Elective – IV</li>
                    <li> RF and Microwave Engineering Lab</li>
                    <li> Project/ Seminar</li>
                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Technology (Electrical Engineering) </b>
                    –
                    The B.Tech in EE program at ARNI School of Technology is designed to provide thorough knowledge
                    about topics such as electromagnetism, electricity and its fundamentals, and electronics. There are
                    eight semesters in this four-year degree program.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester I
                </b>: Foundation</p>
                <ul>
                    <li> Engineering Mathematics I</li>
                    <li> Engineering Physics/Chemistry I</li>
                    <li> Introduction to Electronics</li>
                    <li> Fundamentals of Computing</li>
                    <li> Engineering Graphics</li>
                    <li> Engineering Materials</li>
                    <li> Physics/Chemistry Laboratory</li>

                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester II
                </b>: Fundamentals of Engineering</p>
                <ul>
                    <li> Engineering Mathematics I</li>
                    <li> Engineering Mathematics II</li>
                    <li> Engineering Physics/Chemistry II</li>
                    <li> Computer Programming</li>
                    <li> Electrical Technology</li>
                    <li> Electricity and Magnetism</li>
                    <li> Signals, Systems and Networks</li>
                    <li> Data Structures and Algorithms I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester III
                </b>: Core Engineering Concepts</p>
                <ul>
                    <li> Computational Methods in Engineering</li>
                    <li> Properties and Nature of Materials</li>
                    <li> Introduction to Electrical Engineering</li>
                    <li> Probability and Statistics</li>
                    <li> Electrical Instrumentation</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester IV
                </b>: Advanced Systems</p>
                <ul>
                    <li> Control System Analysis</li>
                    <li> Principles of Communication</li>
                    <li> Applied Thermodynamics</li>
                    <li> Mechanics of Solids, Waves & Special Relativity</li>
                    <li> Introduction to Photonics</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester V
                </b>: Specialized Studies and Applications</p>
                <ul>
                    <li> Digital Image Processing</li>
                    <li> Numerical and Statistical Methods</li>
                    <li> Electrical Measurements</li>
                    <li> Electromagnetic Theory</li>
                    <li> Electrical Engineering Lab</li>

                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester VI
                </b>: Industry-Aligned Learning</p>
                <ul>
                    <li> Virtual Reality (VR)</li>
                    <li> Power Systems</li>
                    <li> Digital Signal Processing</li>
                    <li> Digital Systems Architecture</li>
                    <li> Microprocessors and Computer Organization</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester VII
                </b>: Research and Innovation</p>
                <ul>
                    <li> Machine Learning</li>
                    <li> Microprocessor-based Systems</li>
                    <li> Electrical Power Generation</li>
                    <li> Switchgear and Protection</li>
                    <li> Electric Transportation</li>
                    <li> Artificial Intelligence</li>
                    <li> Project I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester VIII

                </b>: Project & Career Readiness</p>
                <ul>
                    <li> High Voltage Engineering</li>
                    <li> Industrial Automation and Control</li>
                    <li> Robotics</li>
                    <li> Utilization of Electrical Power</li>
                    <li> Optimal Control</li>
                    <li> Optimization Technique</li>
                    <li> Project II</li>
                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Diploma in Electrical Engineering – </b> –
                    ARNI School of Technology offers a Diploma in Electrical Engineering for those students who want to
                    gain skills in analyzing, designing, developing, and troubleshooting electrical systems using
                    numerous tools. The course covers topics such as digital circuits, machines, transformers, and
                    control systems. This 3-year diploma is divided into 6 semesters.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester I
                </b>: Foundation</p>
                <ul>
                    <li> Engineering Physics I</li>
                    <li> Engineering Graphics I</li>
                    <li> Engineering Mathematics I</li>
                    <li> Engineering Chemistry I</li>
                    <li> Communication English I</li>
                    <li> Engineering Physics I (Practical)</li>
                    <li> Engineering Chemistry I (Practical)</li>
                    <li> Workshop</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester II
                </b>: Core Concepts</p>
                <ul>
                    <li> Engineering Physics II</li>
                    <li> Engineering Graphics II</li>
                    <li> Engineering Chemistry II</li>
                    <li> Communication English II</li>
                    <li> Applied Mathematics</li>
                    <li> Engineering Physics II (Practical)</li>
                    <li> Engineering Chemistry II (Practical)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester III
                </b>: Core Concepts II</p>
                <ul>
                    <li> Computer Applications</li>
                    <li> Electrical Machines-I</li>
                    <li> Electrical Circuit Theory</li>
                    <li> Electronic Devices and Circuits</li>
                    <li> Electronic Devices and Circuits (Practical)</li>
                    <li> Electrical Circuits and Machines (Practical)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester IV
                </b>: Advanced Concepts</p>
                <ul>
                    <li> Electric Machines-II</li>
                    <li> Digital Electronics</li>
                    <li> Measurements and Instruments</li>
                    <li> Transducers and Signal Conditioners</li>
                    <li> Communication and Life Skills Practice</li>
                    <li> Digital Electronics & Linear Integrated Circuits (Practical)</li>
                    <li> Electrical Machines and Instrumentation (Practical)</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester V
                </b>: Applications</p>
                <ul>
                    <li> MicroController</li>
                    <li> Power System-I</li>
                    <li> Special Electrical Machines</li>
                    <li> Programmable Logic Controller</li>
                    <li> Electrical Machine Controller</li>
                    <li> Elective Theory-I</li>
                    <li> Elective Practical-I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester VI
                </b>: Research and Projects</p>
                <ul>
                    <li> Electrical Estimation and Energy Auditing</li>
                    <li> Power System-II</li>
                    <li> Computer Hardware and Networks</li>
                    <li> Elective Theory-II</li>
                    <li> Elective Practical-II</li>
                    <li> Project/Seminars</li>

                </ul>
            </div>

        </div>
    </div>
</section>
